import {
  Pipe,
  PipeTransform } from '@angular/core';
@Pipe({
  name: 'accountMask'
})
export class AccountMask implements PipeTransform {
  transform(str) {
    return '****' + str.slice(-4);
  }
}
